/** 建築物構造種別 */
export const constructionTypeLabels = [
  { value: '01', label: '木造' },
  { value: '05', label: '鉄骨造' },
  { value: '03', label: '鉄筋及び鉄骨鉄筋コンクリート造' }
] as const
